'use strict';
define([
    'angular',
    'modules/settings/changePassword/changePassword.controller'
],function(angular,ChangePasswordController){
    var app=angular.module('settings.changePassword', []);
    app.controller('ChangePasswordController',ChangePasswordController);
    return app;
});